import { GridOptions } from "ag-grid-enterprise";
import { SymbolCodeRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/symbol-code-renderer/symbol-code-renderer.component";
import { SymbolAmountRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/symbol-amount-renderer/symbol-amount-renderer.component";
import { SymbolCountryRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/symbol-country-renderer/symbol-country-renderer.component";
import { AccountSymbolTableSubscription, SymbolData } from "./account-symbol-table.subscription";

export class AccountSymbolTable extends AccountSymbolTableSubscription {
  options: GridOptions<SymbolData>;

  constructor() {
    super();
    const commonProperties = {
      sortable: false,
      suppressMenu: true,
    };
    const commonheaderClass = "tw-text-dt-text-disabled tw-text-sm";
    this.options = {
      columnDefs: [
        {
          headerName: "Code",
          headerClass: commonheaderClass,
          field: "code",
          cellRenderer: SymbolCodeRendererComponent,
          ...commonProperties,
        },
        {
          headerName: "Amount",
          headerClass: commonheaderClass,
          field: "amount",
          cellRenderer: SymbolAmountRendererComponent,
          cellRendererParams: { type: "amount" },
          ...commonProperties,
        },
        {
          headerName: `Converted to Core Currency (${this.userStore.preferences.preferenceView().coreCurrency})`,
          headerClass: commonheaderClass,
          field: "convertedAmount",
          cellRenderer: SymbolAmountRendererComponent,
          cellRendererParams: { type: "convertedAmount" },
          ...commonProperties,
        },
        {
          headerName: "",
          headerClass: commonheaderClass,
          field: "country",
          cellRenderer: SymbolCountryRendererComponent,
          ...commonProperties,
        },
      ],
      onGridReady: (params) => params.api.sizeColumnsToFit(),
      suppressContextMenu: true,
    };
  }
}
